module.exports = __webpack_public_path__ + "1e4e654f954d16dfd65640d1fcf5f040.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/background_sounds/campfire.png
// module id = 3346
// module chunks = 0